import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { TRANSLATE_LANGUAGES, type IAdc, type IDetailSummaryResponse, type IdeaContent, type IBaseSolution, type IPatentGPTSummary } from '@/types';
import { getGPTSummary, getPatentSummaryData } from '@/infrastructure/api-functions';
import { controlDeferred } from '@eureka/utils/control';

const handleADCLink = (adcData: IAdc[]) => {
    adcData.forEach(a => {
        a.href = `${import.meta.env.VITE_EUREKA_URI}/results/#/standard?q=ADC:"${a.description}"&_type=query&playbook=SmartSearch`
    })
}

export function useSummary(props: {
    translateMode: TRANSLATE_LANGUAGES,
    inputLang: TRANSLATE_LANGUAGES,
    editContent: IdeaContent,
    detailBasicInfo: IBaseSolution
}) {
    const route = useRoute();
    const patentSummary = ref<IDetailSummaryResponse>();
    const gptSummary = ref<IPatentGPTSummary>();
    const isLoading = ref(false);
    const gptLoading = ref(false);
    const patentId = computed(() => route.params.id as string)
    const isFreeUser = ref(false)

    const stopWatcher = watch(() => {
        return [props.translateMode, patentId.value]
    }, () => {
        if (props.translateMode === TRANSLATE_LANGUAGES.NONE) return
        isLoading.value = true;
        gptSummary.value = undefined;
        getPatentSummaryData({
            patent_id: patentId.value,
            lang: props.inputLang,
            trans_lang: props.translateMode,
            means: props.editContent.means,
            efficacy: props.editContent.efficacy,
        }).then((res) => {
            const { full_efficacy: EFFICACY, full_means: MEANS } = props.detailBasicInfo
            patentSummary.value = {
                ...res,
                EFFICACY,
                MEANS,
            }
            handleADCLink(patentSummary.value.ADC)
        }).finally(() => {
            isLoading.value = false;
        })

        controlDeferred.promise.then(
            ({ freemium }) => {
                isFreeUser.value = freemium
                /**
                * 是否是免费用户
                */
                if (isFreeUser.value) return
                gptLoading.value = true;
                getGPTSummary({
                    patent_id: patentId.value,
                    lang: props.inputLang,
                    trans_lang: props.translateMode,
                }).then((res) => {
                    gptSummary.value = res
                }).finally(() => {
                    gptLoading.value = false;
                })
            }
        )
    }, { immediate: true, flush: 'post' })

    onBeforeUnmount(() => {
        stopWatcher();
    });

    return {
        patentSummary,
        gptSummary,
        isLoading,
        gptLoading,
        isFreeUser,
        patentId,
    };
}
